import { createSlice } from "@reduxjs/toolkit";
import { approvePharmacyOrder } from "../../reducer/approvePharmacyOrder/approvePharmacyOrderReducer";

const initialState = {
  data: null,
  isLoading: false,
  error: null,
};

const approvePharmacyOrderSlice = createSlice({
  name: "approvePharmacyOrder",
  initialState,
  reducers: {
    resetApprovePharmacyOrder: (state) => {
      state.data = null;
      state.isLoading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(approvePharmacyOrder.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(approvePharmacyOrder.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
        state.error = null;
      })
      .addCase(approvePharmacyOrder.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || action.error.message;
      });
  },
});

export const { resetApprovePharmacyOrder } = approvePharmacyOrderSlice.actions;
export default approvePharmacyOrderSlice.reducer;
